import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.refreshghost && _vm.antighost)?_c(VOverlay,{attrs:{"opacity":"1.00","z-index":"500","color":"#FFFFFF"}}):_vm._e(),_c('main',[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }